var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cancel_svg__a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cancel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m20 21.475 5.386 5.386q.3.301.73.31a1 1 0 0 0 .744-.31 1.01 1.01 0 0 0 0-1.474L21.474 20l5.386-5.386q.301-.301.31-.73a1 1 0 0 0-.31-.745 1.01 1.01 0 0 0-1.474 0L20 18.526l-5.386-5.387q-.301-.3-.73-.31a1 1 0 0 0-.745.31 1.01 1.01 0 0 0 0 1.475L18.525 20l-5.387 5.387q-.3.3-.31.73a1 1 0 0 0 .31.744 1.01 1.01 0 0 0 1.475 0zm.002 14.359q-3.268 0-6.153-1.247a16.1 16.1 0 0 1-5.037-3.398 16 16 0 0 1-3.399-5.035q-1.247-2.883-1.247-6.15 0-3.286 1.247-6.176 1.245-2.89 3.397-5.029a16.2 16.2 0 0 1 5.035-3.385q2.884-1.247 6.152-1.247 3.285 0 6.175 1.247 2.89 1.246 5.028 3.383 2.139 2.137 3.385 5.027 1.248 2.89 1.248 6.173 0 3.268-1.247 6.153a16.2 16.2 0 0 1-3.384 5.037q-2.137 2.152-5.026 3.4-2.889 1.246-6.174 1.247"
  }))));
};
export default SvgCancel;